import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ConfigService, XpressUserService, AppDataService } from 'app/services';
import { Utils } from 'app/utils';
import {
    FieldTypeEnum,
    MenuPermissionActionEnum,
    UsersDisiplinaryFilterEnum,
    XpressDisciplinaryPeriodModel
} from 'app/models';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'customers-suspend-and-blacklist',
    templateUrl: './customers-suspend-and-blacklist.component.html',
    styleUrls: ['./customers-suspend-and-blacklist.component.scss',
        '../../../../../styles/style-layout.scss',
        '../../../../../styles/paginator.scss'
    ],
    providers: [MessageService]
})
export class CustomersSuspendAndBlacklistComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    public fieldTypeEnum = FieldTypeEnum;
    public tableName: string = '';
    public usersDisiplinaryFilterActive!: UsersDisiplinaryFilterEnum;
    @Input()
    set _usersDisiplinaryFilterActive(value: UsersDisiplinaryFilterEnum) {
        this.usersDisiplinaryFilterActive = value;

        if (this.usersDisiplinaryFilterActive === UsersDisiplinaryFilterEnum.Suspended) {
            this.tableName = EditTableConfig.SUSPENDED_USERS;
        } else if (this.usersDisiplinaryFilterActive === UsersDisiplinaryFilterEnum.Blacklist) {
            this.tableName = EditTableConfig.BLACKLISTED_USERS;
        }

        this.handleLazyLoad({
            first: 0,
            rows: this.rowsPerPage
        });
    }

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public arrayFilterUpdatedBy: any = [];

    public disciplinaryPeriodModelList = XpressDisciplinaryPeriodModel.XpressDisciplinaryPeriodList;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Users' },
        { label: (this.usersDisiplinaryFilterActive === UsersDisiplinaryFilterEnum.Suspended) ? EditTableConfig.SUSPENDED_USERS : EditTableConfig.BLACKLISTED_USERS }];

    constructor(
        private messageService: MessageService,
        private xpressUserService: XpressUserService,
        public configService: ConfigService, public appDataService: AppDataService
    ) { }

    public isVisibleCustomerInfo: boolean = false;
    public userId!: number;
    public isBanned!: boolean;

    ngOnInit(): void {
        this.representativeFullName = this.appDataService.authData.userName;
    }

    public cols: any[] = [
        { field: 'StatusText',fieldType: FieldTypeEnum.Dropdown, model: 'suspendedPeriod', options: this.disciplinaryPeriodModelList,
            header: 'Status', width: '100px', placeholder: 'Please Select', active: false },
        { field: 'UserId', fieldType: FieldTypeEnum.InputNumber, model: 'userId',
            header: 'User ID', width: '100px', placeholder: 'Type here', active: false },
        { field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'userName',
            header: 'User Name', width: '100px', placeholder: 'Type here', active: false },
        { field: 'UserNameUpdatedBy', fieldType: FieldTypeEnum.Dropdown, model: 'updatedBy', options: this.arrayFilterUpdatedBy,
            header: 'Updated by', width: '250px', placeholder: 'Please Select', active: false }
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
    } = { searchName: '' };

    public loading: boolean = true;
    private searchTimer: number = 0;

    public xpressUsers: any = [];

    public arrayFilterPriorities: any = [];
    public arrayFilterOffense: any = [];
    public arrayFilterDisciplinaryType: any = [];

    public userHeaderSearch: any = {
        suspendedPeriod: null,
        userId: null,
        userName: null,
        updatedBy: null
    };
    public representativeFullName: string = '';

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        this.sortField = event.sortField ? event.sortField : '';

        if (event.sortOrder) {
            this.sortOrder = event.sortOrder;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getUsersSuspendedAndBlacklist(skip);
        this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Users' },
            { label: (this.usersDisiplinaryFilterActive === UsersDisiplinaryFilterEnum.Suspended)
                    ? EditTableConfig.SUSPENDED_USERS
                    : EditTableConfig.BLACKLISTED_USERS }];
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public getUsersSuspendedAndBlacklist(skip: number) {
        if (this.usersDisiplinaryFilterActive) {
            this.loading = true;

            const dto = {
                UsersDisiplinaryFilter: this.usersDisiplinaryFilterActive,
                SearchName: this.filter.searchName,
                SuspendedPeriod: this.userHeaderSearch.suspendedPeriod,
                UserId: this.userHeaderSearch.userId,
                UserName: this.userHeaderSearch.userName,
                UpdatedBy: this.userHeaderSearch.updatedBy ? this.userHeaderSearch.updatedBy : null,
                TimeZoneOffset: Utils.getTimezoneOffset(),
                Skip: skip,
                Take: this.rowsPerPage,
                SortField: this.sortField,
                SortOrder: this.sortOrder
            };

            this.xpressUserService.getUsersSuspendedAndBlacklist(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.loading = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }

                    this.first = skip;
                    this.totalRecords = data.TotalRecords;
                    this.xpressUsers = data.Items;

                    this.xpressUsers.forEach((item: any) => {
                        if (this.usersDisiplinaryFilterActive === UsersDisiplinaryFilterEnum.Suspended) {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#F77F00';
                            item.StatusText = (item.SuspendedPeriodText)
                                ? 'Suspended' + ' ' + item.SuspendedPeriodText
                                : 'No Suspension';
                        } else {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#EB4236';
                            item.StatusText = 'Banned';
                            item.IsBanned = true;
                        }
                        this.mergeUpdatedByDuplicates(item.UserNameUpdatedBy, item.UserNameUpdatedBy);
                    });
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    throw err;
                });
            this.mergeUpdatedByDuplicates('All', 0);
        }
    }

    public handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getUsersSuspendedAndBlacklist(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public mergeUpdatedByDuplicates(name: string, value: any) {
        const exists = this.arrayFilterUpdatedBy.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterUpdatedBy.push({
                name,
                value
            });
        }
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getUsersSuspendedAndBlacklist(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handlePopupLinkClick(user: any, showEditFields: boolean): void {
        if (this.appDataService.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create) ||
            this.appDataService.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Update)) {
            this.userId = user.UserId;
            this.isBanned = user.IsBanned;
            this.isVisibleCustomerInfo = true;
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }
    changedVisibleCustomerInfoEmit(value: any) {
        this.isVisibleCustomerInfo = value;
    }

    onCustomerSuspendSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getUsersSuspendedAndBlacklist(this.first);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer suspended successfully' });
    }

    onCustomerBanSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getUsersSuspendedAndBlacklist(this.first);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer banned successfully' });
    }

    onCustomerLiftSuspensionSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getUsersSuspendedAndBlacklist(this.first);
        this.messageService.add({ severity: 'success', summary: 'Suspension lifted', detail: 'Account successfully restored to Active.' });
    }

    onCustomerLiftBanSuccess() {
        this.isVisibleCustomerInfo = false;
        this.getUsersSuspendedAndBlacklist(this.first);
        this.messageService.add({ severity: 'success', summary: 'Ban lifted', detail: 'Account successfully restored to Active.' });
    }

    protected readonly UsersDisiplinaryFilterEnum = UsersDisiplinaryFilterEnum;
}
